import { render } from "./VToolbar.vue?vue&type=template&id=415a4962"
import script from "./VToolbar.vue?vue&type=script&lang=js"
export * from "./VToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__